import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useQuestionnaireListContext } from "../context/useQuestionnaireList";
import { FoodsIcon, FoodsIconButton, LinearProgress } from "@foodpilot/foods";
import { ViewSwitch } from "./ViewSwitch";
import { useTranslation } from "react-i18next";

export const HeadingList = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isLocked, post, view, setView, hasScoresToDisplay, isMobileOrTablet, lastChangedAtDate, lastUpdatePost } =
        useQuestionnaireListContext();

    return (
        <Stack
            bgcolor={theme.custom.grey[200]}
            border={`1px solid ${theme.custom.grey[600]}`}
            borderRadius={theme.spacing(1.5)}
            height={`fit-content`}
        >
            <Stack
                flexDirection={"row"}
                justifyContent={"space-between"}
                padding={theme.spacing(2, 3)}
                borderBottom={`1px solid ${theme.custom.grey[600]}`}
            >
                <Stack gap={theme.spacing(1)}>
                    <Stack
                        flexDirection={{ xs: "column", sm: "row" }}
                        gap={theme.spacing(1)}
                        alignItems={{ xs: "start", sm: "center" }}
                    >
                        <Typography variant="h5">{t("questionnaire.total_completion", "Total completion:")}</Typography>
                        <Stack width={"200px"}>
                            <LinearProgress value={post?.completions.ssq.result ?? 0} />
                        </Stack>
                    </Stack>
                    {isLocked ?
                        <Typography
                            variant="body-bold"
                            sx={{
                                color: theme.custom.green[600],
                                display: "flex",
                                gap: theme.spacing(1),
                            }}
                        >
                            <Box paddingTop={"4px"}>
                                <FoodsIcon size={2} icon={"check"} />
                            </Box>
                            {t("questionnaire.validated_on", "Validated on: {{date}}", {
                                date: lastUpdatePost,
                            })}
                        </Typography>
                    :   <Typography variant="body-medium" sx={{ color: theme.custom.grey[2000] }}>
                            {t("questionnaire.last_modified", "Last modified: {{date}}", {
                                date: lastChangedAtDate,
                            })}
                        </Typography>
                    }
                </Stack>
                <Stack justifyContent={"center"} alignItems={"center"}>
                    <FoodsIconButton
                        size={"s"}
                        icon={view === "list" ? "gridView" : "formatNumberedList"}
                        withBackground
                        buttonProps={{
                            onClick: () => {
                                view === "list" ? setView("grid") : setView("list");
                            },
                        }}
                        tooltip={{
                            text:
                                view === "grid" ?
                                    t("questionnaire.switch_to_list", "Switch to list")
                                :   t("questionnaire.switch_to_grid", "Switch to grid"),
                        }}
                    />
                </Stack>
            </Stack>
            <Stack
                alignItems="center"
                padding={theme.spacing(2)}
                bgcolor={"white"}
                sx={{
                    borderBottomLeftRadius: theme.spacing(1.5),
                    borderBottomRightRadius: theme.spacing(1.5),
                }}
            >
                <ViewSwitch />
            </Stack>
        </Stack>
    );
};
